export default {
  // System Common
  'sys.serialNumber': '序号',
  'sys.status': '状态',
  'sys.operation': '操作',
  'sys.cancel': '取消',
  'sys.confirm': '确定',
  'sys.add': '新增',
  'sys.edit': '编辑',
  'sys.preview': '预览',
  'sys.delete': '删除',
  'sys.enable': '启用',
  'sys.disable': '禁用',
  'sys.search': '查询',
  'sys.reset': '重置',
  'sys.total': '共 {total} 条',
  'sys.addSuccess': '新增成功',
  'sys.editSuccess': '编辑成功',
  'sys.deleteSuccess': '删除成功',
  'sys.enableSuccess': '启用成功',
  'sys.disableSuccess': '禁用成功',
  'sys.addFailed': '新增失败',
  'sys.editFailed': '编辑失败',
  'sys.deleteFailed': '删除失败',
  'sys.enableFailed': '启用失败',
  'sys.disableFailed': '禁用失败',
  'sys.confirmDelete': '确定要删除吗？',
  'sys.confirmEnable': '确定要启用吗？',
  'sys.confirmDisable': '确定要禁用吗？',
  'sys.required': '必填项',
  'sys.pleaseSelect': '请选择',
  'sys.pleaseEnter': '请输入',
  'sys.all': '全部',
  'sys.enabled': '已启用',
  'sys.disabled': '已禁用',
  'sys.operator': '操作人',
  'sys.operateTime': '操作时间',

  // Email Template Modal
  'email.template.modal.title.edit': '编辑邮件模板',
  'email.template.modal.title.add': '新增邮件模板',
  'email.template.modal.language': '语言',
  'email.template.modal.language.placeholder': '请选择语言',
  'email.template.modal.businessType': '业务类型',
  'email.template.modal.businessType.placeholder': '请选择业务类型',
  'email.template.modal.subject': '邮件标题',
  'email.template.modal.subject.placeholder': '请输入邮件标题',
  'email.template.modal.content': '邮件模板',
  'email.template.modal.content.placeholder': '请输入邮件内容',
  'email.template.modal.sender': '显示发件人',
  'email.template.modal.sender.placeholder': '请输入显示发件人',
  'email.template.modal.format': '邮件格式',
  'email.template.modal.format.placeholder': '请选择邮件格式',
  'email.template.modal.receipt': '是否需要回执',
  'email.template.modal.receipt.placeholder': '请选择是否需要回执',
  'email.template.modal.receipt.yes': '是',
  'email.template.modal.receipt.no': '否',

  // Email Config Modal
  'email.config.modal.title.edit': '编辑邮件',
  'email.config.modal.title.add': '新增邮件',
  'email.config.modal.type': '邮件类型',
  'email.config.modal.type.placeholder': '请选择邮件类型',
  'email.config.type.80002001': '微软邮箱',
  'email.config.type.80002002': '谷歌邮箱',
  'email.config.modal.account': '邮箱地址',
  'email.config.modal.account.placeholder': '请输入邮箱地址',
  'email.config.modal.password': '邮箱密码',
  'email.config.modal.password.placeholder': '请输入邮箱密码',
  'email.config.modal.smtp': 'SMTP',
  'email.config.modal.smtp.placeholder': '请输入SMTP地址',
  'email.config.modal.port': '端口',
  'email.config.modal.port.placeholder': '请输入端口号',

  // Email Template List
  'email.template.list.title': '邮件模板列表',
  'email.template.list.search.businessType': '业务类型',
  'email.template.list.search.language': '语言',
  'email.template.list.search.button': '查询',
  'email.template.list.search.reset': '重置',
  'email.template.list.add': '新增',
  'email.template.list.edit': '编辑',
  'email.template.list.enable': '启用',
  'email.template.list.disable': '禁用',
  'email.template.list.delete': '删除',
  'email.template.list.delete.confirm': '确定要删除吗？',
  'email.template.list.status.enabled': '已启用',
  'email.template.list.status.disabled': '已禁用',
  'email.template.list.operator': '操作人',
  'email.template.list.operateTime': '操作时间',

  // Email Config List
  'email.config.list.title': '邮件配置列表',
  'email.config.list.search.status': '状态',
  'email.config.list.search.status.all': '全部',
  'email.config.list.search.status.enabled': '已启用',
  'email.config.list.search.status.disabled': '已禁用',
  'email.config.list.search.account': '邮箱地址',
  'email.config.list.search.account.placeholder': '请输入邮箱地址',
  'email.config.list.search.button': '查询',
  'email.config.list.search.reset': '重置',
  'email.config.list.add': '新增邮件',
  'email.config.list.edit': '编辑',
  'email.config.list.enable': '启用',
  'email.config.list.disable': '禁用',
  'email.config.list.delete': '删除',
  'email.config.list.delete.confirm': '确定要删除吗？',
  'email.config.list.status.enabled': '已启用',
  'email.config.list.status.disabled': '已禁用',
  'email.config.list.operator': '操作人',
  'email.config.list.operateTime': '操作时间',
}; 